import React from 'react'

const renderField = ({ input, placeholder, type, onKeyUp, className, disabled, autoComplete, meta: { touched, error } }) => (
  <div style={{ width: '100%' }}>
    <input {...input} placeholder={placeholder} type={type} onKeyUp={onKeyUp} className={className} disabled={disabled} autoComplete={autoComplete} />
    {touched && error && <span className="error_field">{error}</span>}
  </div>
)

export { renderField }



// WEBPACK FOOTER //
// ./src/components/utils/input.js